module.exports = __webpack_public_path__ + "img/suit-08.9dcfbe68.png";